import React, { Component } from "react";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "jspdf-autotable";
import { imgData } from "../../../utils/Global";
import * as jsPDF from "jspdf";
import {
  main_url,
  getUserId,
  getMainRole,
  getInformation,
  print,
  fno,
} from "../../../utils/CommonFunction";
import { getHeaders } from "../../../utils/apiHelper";
import DateTimeService from "../../../utils/dateTimeService";
const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class BenefitChildTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: getUserId("user_info"),
      dataSource: props.data,
      selectedRequest: "",
      is_main_role: getMainRole(),
      branchlist: [],
      jobList: props.jobList,
      transactionTypesList: props.transactionTypesList,
      demotionReasonsList: props.demotionReasonsList,
      exitStatusList: this.props.exitStatusList,
      regionList: props.regionList,
    };
  }

  componentDidMount() {
    this.getBranchList();
    this.$el = $(this.el);
    this.setState(
      {
        dataSource: this.props.data,
      },
      () => {
        this._setTableData(this.state.dataSource);
      }
    );

    let that = this;
    $("#dataTables-table").on("click", "#toView", function () {
      var data = $(this).find("#view").text();
      data = $.parseJSON(data);
      that.props.goToSingleViewForm(data);
    });

    // $("#dataTables-table").on('click', '#toPrint', function () {

    //     fetch(`${main_url}child_benefit/getChildAvailableAmount`, {
    //   headers: getHeaders(),
    // })
    //         .then(res => { if (res.ok) return res.json() })
    //         .then(list => {
    //             var data = $(this).find("#print").text();
    //             data = $.parseJSON(data);

    //             that.getPrintData(data, list.amount)
    //         })

    // });

    $("#dataTables-table").on("click", "#toEdit", function () {
      var data = $(this).find("#edit").text();
      data = $.parseJSON(data);
      that.props.goToEditForm(data);
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState(
        {
          dataSource: this.props.data,
        },
        () => {
          this._setTableData(this.state.dataSource);
        }
      );
    }
  }

  getBranchList() {
    fetch(`${main_url}benefit/getBranchList`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({ branchlist: list });
      });
  }

  search(status) {
    let data = this.state.dataSource;
    // data.sort(data[1].createdAt);
    // for (let key in data){
    //     console.log("dayaaa",key)
    // }
    data = data.filter((d) => {
      return status === d.status;
    });
    this._setTableData(data);
  }

  _setTableData = (data) => {
    data.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
    var table;
    var l = [];
    var status;
    var permission = this.props.permission;
    var has_action =
      permission.isView === 1 || permission.isEdit === 1 ? true : false;
    var salary_permission = this.props.salaryPermission;
    var salaryTmp = 0.0;

    for (var i = 0; i < data.length; i++) {
      let result = data[i];
      let obj = [];
      //Add by AKM 2023-Aug-11 //Start code

      // Access permission to view above level 7 salary
      if (salary_permission.length > 0) {
        salaryTmp = this.props.salaryList.filter(
          (v) => v.career_sub_level == data[i].career_sub_level
        )
          ? this.props.salaryList.filter(
              (v) => v.career_sub_level == data[i].career_sub_level
            )[0]
            ? this.props.salaryList.filter(
                (v) => v.career_sub_level == data[i].career_sub_level
              )[0].basic_salary
            : 0
          : 0;
      }
      // Don't have access permission to view above level 7 salary
      else if (
        parseInt(data[i].career_level) >= 7 &&
        salary_permission.length == 0
      ) {
        salaryTmp = "";
      }
      // Access permission to view under level 7 salary
      else {
        salaryTmp = this.props.salaryList.filter(
          (v) => v.career_sub_level == data[i].career_sub_level
        )
          ? this.props.salaryList.filter(
              (v) => v.career_sub_level == data[i].career_sub_level
            )[0]
            ? this.props.salaryList.filter(
                (v) => v.career_sub_level == data[i].career_sub_level
              )[0].basic_salary
            : 0
          : 0;
      }
      // End code
      obj = {
        no: i + 1,
        employee_id: data[i].emp_id ? data[i].emp_id : "",
        employee_name: data[i].fullname ? data[i].fullname : "",
        position: data[i].designation_name ? data[i].designation_name : "-",
        employee_status: data[i].status
          ? (this.props.statusList || []).find(
              (status) => Number(status.value) === Number(data[i].status)
            )?.label || data[i].status
          : "-",
        branch: data[i].branch_name ? data[i].branch_name : "",
        date: data[i].createdAt
          ? new DateTimeService(data[i].createdAt).formatDate
          : "-",
        employed_date: data[i].employ_date
          ? new DateTimeService(data[i].employ_date).formatDate
          : "",
        effective_date: data[i].effective_date
          ? new DateTimeService(data[i].effective_date).formatDate
          : "",
        job_title: data[i].job_title
          ? this.state.jobList.filter((d) => d.id == data[i].job_title)[0]
              .job_title
          : "",
        carrer_level: data[i].career_level_name
          ? data[i].career_level_name
          : "",
        carrer_sub_level: data[i].career_sub_level_name
          ? data[i].career_sub_level_name
          : "",
        transaction_type: data[i].transaction_type
          ? this.state.transactionTypesList.find(
              (v) => v.value === result.transaction_type
            ).label
          : "",
        region: data[i].region ? data[i].region : "",
        // salary: data[i].salary ? data[i].salary : '', .length > 0 ? (dta > 20 ? (data ==0 ? ('data is 0") : ("data")) : ()) : ()
        salary: salaryTmp ? salaryTmp : "", //Add by AKM 2023-Aug-11
        //salary: this.props.salaryList.filter(v => v.career_sub_level == data[i].career_sub_level) ? this.props.salaryList.filter(v => v.career_sub_level == data[i].career_sub_level)[0] ? this.props.salaryList.filter(v => v.career_sub_level == data[i].career_sub_level)[0].basic_salary : 0 : 0,
        promotion_date: data[i].promotion_date ? data[i].promotion_date : "-",
        // salary: this.props.salaryPermission.length > 0 ? data[i].salary ? data[i].salary : this.props.salaryList.filter(v=>v.career_sub_level==data[i].career_sub_level)[0] ? this.props.salaryList.filter(v=>v.career_sub_level==data[i].career_sub_level)[0].basic_salary: ''
        // : data[i].career_sub_level > 20 ? 'Not Available' : data[i].salary ? data[i].salary : this.props.salaryList.filter(v=>v.career_sub_level==data[i].career_sub_level)[0].basic_salary,
        department: data[i].deptname ? data[i].deptname : "",
        discon_status: data[i].discontinute_status
          ? data[i].discontinute_status == 0
            ? "False"
            : "True"
          : "False",
        discon_date: data[i].discontinute_date
          ? new DateTimeService(data[i].discontinute_date).formatDate
          : "",
        resign_reason: data[i].resign_reason ? data[i].resign_reason : "",
        exit_status: this.props.exitStatusList.filter(
          (v) => v.id == data[i].exit_status
        )
          ? this.props.exitStatusList.filter(
              (v) => v.id == data[i].exit_status
            )[0]
            ? this.props.exitStatusList.filter(
                (v) => v.id == data[i].exit_status
              )[0].label
            : ""
          : "",
        actual_date: data[i].actual_date
          ? new DateTimeService(data[i].actual_date).formatDate
          : "",
        attachment: "",
        remark: data[i].remark,
        demotion_reason: data[i].demotion_reason
          ? this.state.demotionReasonsList.find(
            (v) => v.value === result.demotion_reason
          ).label
          : "",
        monitoring_end_date: new DateTimeService(data[i].monitoring_end_date).formatDate,
        last_working_date: new DateTimeService(data[i].last_working_date).formatDate,
      };

      if (data[i].attachment) {
        obj.attachment = `<a
          href=${main_url}employee/getCRDocumentData/${this.state.user_id}/${data[i].attachment}
          download
          target="_blank"
          className="btn btn-primary document-body-bt document-width"
        >
          <img
              src="assets/icons/attach_file.svg"
              alt=""
              height="20"
              width="20" 
            />
        </a>`;
      }

      if (has_action) {
        // if (result.status !== 3) {
        obj.action =
          permission.isView === 1
            ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' +
              JSON.stringify(result) +
              '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>'
            : "";
        obj.action +=
          permission.isEdit === 1 ||
          (result.status == 5 && data[i].createdBy == this.state.user_id)
            ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toEdit" ><span id="edit" class="hidden" >' +
              JSON.stringify(result) +
              '</span>  <i className="fa fa-cogs"></i>&nbsp;Edit</button>'
            : "";
        // } else {
        //     obj.action = permission.isView === 1 ?
        //         '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' + JSON.stringify(result) + '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>' : '';

        //     if (result.print === 1) {
        //         obj.action +=
        //             '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
        //             JSON.stringify(result) +
        //             '</span>  <i className="fa fa-cogs"></i>&nbsp;Printed</button>';
        //     } else {
        //         obj.action +=
        //             '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
        //             JSON.stringify(result) +
        //             '</span>  <i className="fa fa-cogs"></i>&nbsp;Print</button>';
        //     }
        // }
      }

      l.push(obj);
    }

    if ($.fn.dataTable.isDataTable("#dataTables-table")) {
      table = $("#dataTables-table").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-table").empty();
    }

    var column = [
      { title: "No", data: "no" },
      { title: " Date", data: "date" },
      { title: "Employee Code", data: "employee_id" },
      // { title: "Form No", data: "form_no" },
      { title: "Employee Name", data: "employee_name" },
      { title: "Transaction Type", data: "transaction_type" },
      { title: "Employee Status", data: "employee_status" },
      { title: "Employed Date", data: "employed_date" },
      { title: "Effective Date", data: "effective_date" },
      { title: "Promotion Date", data: "promotion_date" },
      { title: "Arrival Date", data: "actual_date" },
      { title: "Designation", data: "position" },
      { title: "Job Title", data: "job_title" },
      { title: "Career Level", data: "carrer_level" },
      { title: "Career Sub Level", data: "carrer_sub_level" },
      { title: "Salary", data: "salary" },
      { title: "Branch", data: "branch" },
      { title: "Department", data: "department" },
      { title: "Region", data: "region" },
      { title: "Reason of Demotion", data: "demotion_reason" },
      { title: "End of Monitoring Date", data: "monitoring_end_date" },
      { title: "Last Working Date", data: "last_working_date" },
      { title: "Discontinue Status", data: "discon_status" },
      { title: "Discontinue Date", data: "discon_date" },
      { title: "Resign Reason", data: "resign_reason" },
      { title: "Exit Status", data: "exit_status" },
      { title: "Attachment", data: "attachment" },
      { title: "Remark", data: "remark" },

      // { title: "Status", data: "status" }
    ];

    if (has_action) {
      column.push({ title: "Action", data: "action" });
    }
    table = $("#dataTables-table").DataTable({
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      pageLength: 50,
      paging: true,
      // buttons: true,
      dom: "Bfrtip",
      // buttons: [
      //     'copy', 'csv', 'excel', 'pdf'
      // ],
      buttons: [
        // 'copy',
        // {
        //         extend: 'csvHtml5',
        //         title: 'Child Benefit',
        // },
        // {
        //     extend: 'excelHtml5',
        //     title: 'Child Benefit',
        // },
        // {
        //     extend: 'pdfHtml5',
        //     title: 'Child Benefit',
        // }
      ],
      data: l,
      columns: column,
    });
  };

  render() {
    return (
      <div>
        <table
          width="99%"
          className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive"
          id="dataTables-table"
        />
      </div>
    );
  }
}
